<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="doc-header doc-title">
          <strong>{{ title }}</strong>
          <span class="title-filter">Lương tháng: </span>
          <Calendar id="range" v-model="filterDate" selectionMode="range" :numberOfMonths="2" :manualInput="false" dateFormat="dd/mm/yy" :show-icon="true"/>
          <Button label="Tìm" @click="onEnter" class="p-button-success btn-enter-filter"/>
          <div class="box-selected-file" v-if="this.$store.getters.group_permission && this.$store.getters.group_permission.employee_payroll.export == true || this.$store.getters.role == 'admin'">
            <!-- <input type="file" name="exportFile" class="file" @change="onExportExcel"/>
            <span class="btn-span">Xuất Excel</span> -->
            <div class="opacity"/>
            <ExportExcel
              :fields="exportConfigs1.fields"
              :fetch="exportConfigs1.fetch"
              :colHeaderStyle="exportConfigs1.colHeaderStyle"
              :name="exportConfigs1.name"
              :subTitle="exportConfigs1.subTitle"
            >
              <span class="btn-span">Xuất Excel</span>
            </ExportExcel>
          </div>
          
        </div>
        
        <DataTable
          :value="listData"
          class="p-datatable-responsive"
          dataKey="id"
          :selection.sync="selectedRows"
          :paginator="pagination"
          :rows="paginationRows"
          :loading="loading"
          :filters="filters"
          :scrollable="(scrollHeight !== '' ? true : false) "
          :scrollHeight="scrollHeight"
          :autoLayout="true"
          :key="componentKey"
          :rowsPerPageOptions="rowsPerPageOptions"
          currentPageReportTemplate="Tổng số: {totalRecords}"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        >
          <!-- <Column selectionMode="multiple" headerStyle="width: 3rem"></Column> -->
          <Column 
            v-for="c in dataModel.getDisplayFields()"
            :key="c.key"
            :field="getField(c)"
            :header="getLabel(c)"
            :filterMatchMode="getFilterMatch(c)"
            :sortable="getSortable(c)"
            :bodyClass="(c.class ? 'txt-' + c.class : '')"
            :bodyStyle="getHeaderStyle(c)"
            :headerStyle="getHeaderStyle(c)"
            :headerClass="(c.class ? 'txt-' + c.class : '')"
          >
            <template #body="slotProps">
              <img
                v-if="getType(c) == 'Image'"
                :src="getData(c, slotProps.data)"
                style="width: 40px; heigth: 40px"
              />
              <div
                v-else-if="c.type == 'Text'"
                v-html="getData(c, slotProps.data)"
                :style="(c.style ? c.style : '')"
              ></div>
              <div
                v-else-if="getType(c) == 'Custom' || getType(c) == 'Icon'"
                v-html="getData(c, slotProps.data)"
                :style="(c.style ? c.style : '')"
              ></div>

              <Checkbox
                v-else-if="getType(c) == 'Checkbox'"
                v-model="slotProps.data[slotProps.column.field]"
                :binary="true"
                @change="onInputChange($event, slotProps.data, c)"
              />
              <span v-else v-html="getData(c, slotProps.data)" :class="getCustomClass(c, slotProps.data[c.key], slotProps.data)"></span>
            </template>
            <template v-if="c.filter" #filter>
              <InputText
                v-if="c.filter.type == 'input'"
                type="text"
                v-model="filters[c.key]"
                class="p-column-filter"
                :placeholder="getFilterPlaceHolder(c)"
              />
              <Dropdown
                :key="countDropdown"
                v-if="c.filter.type == 'select'"
                v-model="filters[getField(c)]"
                :options="getFilterOptions(c.key)"
                :optionLabel="c.filter.optionLabel"
                :optionValue="c.filter.optionKey"
                :placeholder="getFilterPlaceHolder(c)"
                class="p-column-filter"
                :showClear="true"
                appendTo="body"
              >
                <template #option="slotProps">
                  <div class="p-clearfix">
                    <span
                      :class="getCustomClass(c, slotProps.option[c.filter.optionKey], slotProps.data)"
                      >{{ slotProps.option[c.filter.optionLabel] }}</span
                    >
                  </div>
                </template>
              </Dropdown>
              <Calendar 
                v-if="c.filter.type == 'DateRange'"
                :showOnFocus="false" 
                :monthNavigator="true" 
                :yearNavigator="true" 
                yearRange="2000:2030" 
                dateFormat="yy-mm-dd" 
                id="date_from" 
                v-model="filters[getField(c)]" 
                class="p-column-filter"
                :showIcon="true" 
                selectionMode="range"
                appendTo="body"
                :showClear="true"
                @date-select="select_date($event,getField(c))"
                :manualInput="false"
                />
            </template>
          </Column>
          <template #empty>
            {{ $t('datatable.empty') }}
          </template>
          <template #loading>
            {{ $t('datatable.loading') }}
          </template>
          
        </DataTable>

      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import gql from "graphql-tag";
import moment from "moment-timezone";
// import XLSX from "xlsx"
import graphql from '../common/graphql'
import store from '@/store'
export default {
  components: {
  },
  data() {
    return {
      filterOptions: {},
      listData: [],
      modelName: '',
      dataModel: null,
      title: '',
      componentKey: 0,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      // 
      filters: {},
      countDropdown: 0,
      pagination: true, // true cho phép phân trang
      paginationRows: 10, // số dòng trên 1 trang
      scrollHeight: '', // chiều cao của trang danh sách
      loading: true,
      rowsPerPageOptions: [10, 20, 50, 100],
      selectedRows: null,
      filterDate: null,
      dateFrom: null,
      dateTo: null,
      // EXPORT
      exportConfigs1: {
        sheetInfo: 'CÔNG TY CỔ PHẦN ENGMA',
        header: 'DANH SÁCH VĂN BẢN',
        subTitle: () => {
          let subTitle = '';
          let dateFrom = '...';
          let dateEnd = '...';
          // console.log(data);
          if (this.filterDate !== null) {
            dateFrom = moment(this.filterDate[0]).format('DD/MM/YYYY');
            dateEnd = this.filterDate[1] !== null ? moment(this.filterDate[1]).format('DD/MM/YYYY') : '...';
          }

          subTitle = `Từ ngày ${dateFrom} đến ngày ${dateEnd}`;
          return subTitle;
        },
        colHeaderStyle: 'background-color:#bfbfbf; font-weight: bold; border: solid 1px #fffff',
        fields: {
          'STT  ': 'stt',
          'HỌ TÊN': 'fullname',
          'Mã khu vực': {
            callback: (row) => {
              if (row.areas){
                return (row.areas.code) ? row.areas.code:'';
              }
              return '';
            }
          },
          'Loại 1 (thường)': {
            callback: (row) => {
              return row.type1
            }
          },
          'Loại 1 (trễ)': {
            callback: (row) => {
              return row.type1Late
            }
          },
          'Loại 2 (thường)': {
            callback: (row) => {
              return row.type2
            }
          },
          'Loại 2 (trễ)': {
            callback: (row) => {
              return row.type2Late
            }
          },
          'Loại 3 (thường)': {
            callback: (row) => {
              return row.type3
            }
          },
          'Loại 3 (trễ)': {
            callback: (row) => {
              return row.type3Late
            }
          },
          'Loại 4 (trả tòa)': {
            callback: (row) => {
              return row.type4
            }
          },
          'Loại 5 (đi tỉnh)': {
            callback: (row) => {
              return row.type5
            }
          },
          'Số tiền loại 1 (thường)': {
            callback: (row) => {
              return row.type1Amount
            }
          },
          'Số tiền loại 1 (trễ)': {
            callback: (row) => {
              return row.type1LateAmount
            }
          },
          'Số tiền loại 2 (thường)': {
            callback: (row) => {
              return row.type2Amount
            }
          },
          'Số tiền loại 2 (trễ)': {
            callback: (row) => {
              return row.type2LateAmount
            }
          },
          'Tổng tiền (Loại 1+2)': {
            callback: (row) => {
              return row.type12Amount
            }
          },
          'Tổng tiền loại 5 (đi Tỉnh)': {
            callback: (row) => {
              return row.type5Amount
            }
          },
          
        },
        fetch: async () => {
          let data = [];
          let variables = {
            where: {
              users_account: {
                role: {'_eq': "tdv"},
                deleted: {'_eq': false}
              },
              deleted: {'_eq': false}
            },
            orderBy: {id: 'asc'}
          }
          if (this.filterDate) {
            let date1 = new Date(this.filterDate[0]).toISOString()
            date1 = moment(date1).utc(7).format('YYYY-MM-DDT00:00:00.0[Z]')
            let date2 = this.filterDate[1] !== null ? new Date(this.filterDate[1]).toISOString() : '';
            date2 = moment(date2).utc(7).format('YYYY-MM-DDT23:59:59.0[Z]')
            Object.assign(variables, {date_from: date1, date_to: date2})
          }
          await this.$apollo.query({
            query: gql(graphql.GET_PAYROLL_EMPLOYEE_1),
            variables: variables,
            fetchPolicy: "no-cache"
          }).then(async (resData) => {
            // console.log("=============fetch data", resData)
            let lstdata = resData.data.users;
            for (let i = 0; i < lstdata.length; i++) {
              lstdata[i].type1 = lstdata[i].view_payroll_type1_aggregate.aggregate.count;
              lstdata[i].type1Amount = lstdata[i].view_payroll_type1_aggregate.aggregate.sum.amount_salary !== null && lstdata[i].view_payroll_type1_aggregate.aggregate.sum.amount_salary || 0; 
              lstdata[i].type1Late = lstdata[i].view_payroll_type1_late_aggregate.aggregate.count;
              lstdata[i].type1LateAmount = lstdata[i].view_payroll_type1_late_aggregate.aggregate.sum.amount_salary !== null && lstdata[i].view_payroll_type1_late_aggregate.aggregate.sum.amount_salary || 0;
              lstdata[i].type2 = lstdata[i].view_payroll_type2_aggregate.aggregate.count;
              lstdata[i].type2Amount = lstdata[i].view_payroll_type2_aggregate.aggregate.sum.amount_salary !== null && lstdata[i].view_payroll_type2_aggregate.aggregate.sum.amount_salary || 0;
              lstdata[i].type2Late = lstdata[i].view_payroll_type2_late_aggregate.aggregate.count;
              lstdata[i].type2LateAmount = lstdata[i].view_payroll_type2_late_aggregate.aggregate.sum.amount_salary !== null && lstdata[i].view_payroll_type2_late_aggregate.aggregate.sum.amount_salary || 0;
              lstdata[i].type3 = lstdata[i].view_payroll_type3_aggregate.aggregate.count;
              lstdata[i].type3Late = lstdata[i].view_payroll_type3_late_aggregate.aggregate.count;
              lstdata[i].type4 = lstdata[i].view_payroll_type4_aggregate.aggregate.count;
              lstdata[i].type5 = lstdata[i].view_payroll_type5_aggregate.aggregate.count;
              lstdata[i].type5Amount = lstdata[i].view_payroll_type5_aggregate.aggregate.sum.amount_salary !== null && lstdata[i].view_payroll_type5_aggregate.aggregate.sum.amount_salary || 0;
              lstdata[i].type12Amount = lstdata[i].type1Amount + lstdata[i].type1LateAmount + lstdata[i].type2Amount + lstdata[i].type2LateAmount ;
              lstdata[i].stt = i + 1;
              data.push(lstdata[i]);
            }
          }).catch((error) => {
            console.log(error);
          });
          // console.log("Fecth return", data)
          if (data.length > 0) {
            this.selectedRows = null;
            this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xuất file excel thành công', life: 3000 })
            return data;
          } else {
            this.selectedRows = null;
            this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: 'Không có văn bản giao nhận', life: 3000 })
            return data;
          }
        },
        name: 'Xuất Excel.xls',
      },
    }
  },
  beforeCreate() {
    if (store.getters.group_permission && store.getters.group_permission.employee_payroll.list == false && store.getters.role != "admin") {
      this.$router.push({name: '404'})
    }
  },
  async created() {
    this.modelName = this.$route.meta.model;
    this.dataModel = DataServices.getModel('payroll_employee')
    this.title = this.dataModel.label
    this.$store.commit('setLoading', true);
    // if(this.$route.params.reload) {
    //   window.location.reload();
    // }
    this.loading = false;
    this.countDropdown++;
    // this.$apollo.queries.listData.refresh();
    await this.onCreated();
  },
  mouted() {
  },
  watch: {
    '$route': 'initParams'
  },
  methods: {
    async onCreated() {
      if (this.filterDate !== null) {
        let date1 = new Date(this.filterDate[0]).toISOString()
        this.dateFrom = moment(date1).utc(7).format('YYYY-MM-DDT00:00:00.0[Z]')
        let date2 = this.filterDate[1] !== null ? new Date(this.filterDate[1]).toISOString() : date1;
        this.dateTo = moment(date2).utc(7).format('YYYY-MM-DDT23:59:59.0[Z]')
      }
      await this.$apollo.query({
        query: gql(graphql.GET_PAYROLL_EMPLOYEE_1),
        variables: {
          where: {
            users_account: {
              role: {'_eq': "tdv"},
              deleted: {'_eq': false}
            },
            deleted: {'_eq': false}
          },
          date_from: this.dateFrom,
          date_to: this.dateTo,
          orderBy: {id: 'asc'}
        },
        fetchPolicy: 'network-only'
      }).then((res) => {
         console.log("resresres",res)
        this.listData = [];
        if (res && res.data && res.data.users.length > 0) {
          this.listData = [...res.data.users]
          this.dataModel.processData(this.listData)
          this.$store.commit('setLoading', false);
        }
      }).catch((error) => {
        this.$store.commit('setLoading', false);
        if (error.graphQLErrors && error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.log(error)
      })
    },
    initParams() {
      this.$store.commit('setLoading', true);
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel('payroll_employee');
      // console.log(this.dataModel)
      this.title = this.dataModel.label;
    },
    async onEnter() {
      if (this.filterDate !== null) {
        this.$store.commit('setLoading', true);
        let date1 = new Date(this.filterDate[0]).toISOString()
        this.dateFrom = moment(date1).utc(7).format('YYYY-MM-DDT00:00:00.0[Z]')
        let date2 = this.filterDate[1] !== null ? new Date(this.filterDate[1]).toISOString() : date1
        this.dateTo = moment(date2).utc(7).format('YYYY-MM-DDT23:59:59.0[Z]')
        await this.onCreated();
      }
    },
    onChange() {
      this.$store.commit('setLoading', true);
      this.$apollo.queries.listData.refresh()
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      var result = []
      if (field.type == 'Selection') {
        result = field.options;
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      return result;
    },
    getRowActions() {
      var actions = {}
      var that = this;
      // actions.header = { name: 'add', icon: 'plus', path: `import-document/add`};
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        var buttons = {}
        // buttons.view = { name: 'view', icon: 'eye', key: 'id', path: `list-manager/view/`};
        // buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `list-document/edit/`},
        // buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `${that.modelName}/edit/`}
        // buttons.delete = { name: 'delete', icon: 'trash', key: 'id'}
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async actionsClicked(key, action, data) {
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name
          this.showDeleteDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path })
          } else  {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
      }
    },
    // GỘP HÀM
    select_date(event,col_name) {
      if (this.filters[col_name][0] !== null && this.filters[col_name][1] !== null) {
        this.$emit("filter_date", {
          data: this.filters[col_name],
          col: col_name
        });
      }
    },
    getLabel(col) {
      if (col.label) return col.label;
      else return col.name;
    },
    getType(col) {
      if (col.display?.list?.mode == "custom") {
        return "Custom";
      }
      switch (col.type) {
        case "String":
        case "Text":
        case "Computed":
          if (col.inputOptions?.mode == "Image") {
            return "Image";
          }
          if (col.inputOptions?.mode == "selection") {
            return "Select";
          }
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          }
          if(col.inputOptions?.mode == 'icon') {
            return "Icon";
          }
          return "Input";
        case "numeric":
        case "ShadowField":
        case "number":
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          } else if (col.inputOptions?.mode == "percentage") {
            return "Percentage";
          } else {
            return "Number";
          }
        case "Selection":
          return "Select";
        case "Checkbox":
          return "Checkbox";
        default:
          return col.type;
      }
    },
    onInputChange(value, data, f) {
      if (f.onChange)  f.onChange(data).bind(this);
      this.$emit("onDataChange", data, f);
    },
    getCustomClass(col, data, rowData) {
      if (col.displayClass) return col.displayClass(data, rowData);
      return "";
    },
    getField(col) {
      return col.key;
    },
    getHeaderStyle(col) {
      var style = "";
      if (col.width) style = "width: " + col.width + "em;";
      else if (col.name === "stt" || col.name === "STT") style = "width: 3em;";
      else if (col.type === "image" || col.type === "Image") style = "width: 6em;";
      return style;
    },
    getData(col, row) {
      var value = '';
      if (col.type == "Date" && row[col.key]) {
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("DD/MM/yyyy");
      } else if (col.type == "Datetime" && row[col.key]) {
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("HH:mm:ss DD/MM/yyyy");
      } else if (col.type == "CustomDate" && row[col.key]) {
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("HH:mm - DD/MM/yyyy");
      } else if(col.type == "Hour" && row[col.key]){
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("HH:mm");
      } else if (col.type == "Selection") {
        var lists = [];
        if (col.options !== undefined) {
          lists = col.options;
        } else if (col.models !== undefined && this.options[col.key] !== undefined) {
          lists = this.options[col.key];
        }
        if (lists && lists.length) {
          var objResult = lists.filter(a => a.value == row[col.key]);
          if (objResult !== undefined && Object.keys(objResult) && Object.entries(objResult).length) {
            value = objResult[Object.keys(objResult)].label;
          }
        }
      } else {
        if (col.type == "Text" && row[col.key] && row[col.key].length > 100) {
          var result = row[col.key].substr(0, row[col.key].lastIndexOf(" ", 100)) + "...";
          value = result;
        }
        if (this.getType(col) == "Currency") {
          if (row[col.key] == null) row[col.key] = 0;
          value = this.formatCurrency(row[col.key]);
        }
        if (this.getType(col) == "Percentage") {
          if (row[col.key] == null) row[col.key] = `0%`;
          value = row[col.key] + "%";
        }
        value = row[col.key];
      }
      if (col.style) value = '<abbr style="' + col.style + '">' + value + '<abbr/>';
      else if (col.options) {
        var filtered = col.options.filter( a => a.value  === row[col.key]);
        if (Object.keys(filtered) && Object.entries(filtered).length && filtered[0].style) {
          value = '<abbr style="' + filtered[0].style + '">' + value + '<abbr/>';
        }
      } 
      return value
    },
    getFilterMatch(col) {
      var filterMatch = "startWith";
      if (col.filter && col.filter.match) {
        filterMatch = col.filter.match;
      }
      return filterMatch;
    },
    getFilterPlaceHolder(col) {
      if (col.filter.placeHolder) {
        return col.filter.placeHolder;
      } else if (col.filter.type == "select") {
        return `Chọn ${this.getLabel(col).toLowerCase()}`;
      } else if (col.filter.type == "input") {
        return `Nhập ${this.getLabel(col).toLowerCase()}`;
      } else {
        return `Lọc`;
      }
    },
    getSortable(col) {
      return col.sortable && col.sortable == true ? true : false;
    },
    getIcon(iconName) {
      return `pi pi-${iconName}`;
    },
    getDisabled(disabled = false) {
      return disabled;
    },
    getClass(type) {
      switch (type) {
        case "add":
          return "p-button-add";
        case "delete":
          return "p-button-danger";
        case "edit":
          return "p-button-edit";
        case "adddebt":
          return "p-button-edit"
        case "add-Debt":
          return "p-button-add";
        case "editcustom":
          return "p-button-edit"
        case "addcustom":
          return "p-button-add";
      }
    },
    formatCurrency(value) {
      return value.toLocaleString("vi-VN", {
        style: "currency",
        currency: "VND"
      });
    }
  },
  apollo: {
    // listData: {
    //   query() {
    //     this.modelName = this.$route.meta.model;
    //     return DataServices.getList(this.modelName);
    //   },
    //   variables: {
    //     where_key: {
    //       users_account: {
    //         role: {_eq: "tdv"},
    //         deleted: {_eq: false}
    //       }, 
    //       deleted: {_eq: false}
    //     }
    //   },
    //   update(data) {
    //     this.title = this.dataModel.label + ' '
    //     this.dataModel.processData(listData)
    //     this.$store.commit('setLoading', false);
    //     this.componentKey += 1
    //     if (Object.keys(data).length > 0) {
    //       var listData = data[this.dataModel.tableName]
    //       this.totalDoc = data.users.length;
    //       return data[this.dataModel.tableName]
    //     }
    //   },
    //   fetchPolicy: 'network-only',
    //   error() {
    //     this.$store.commit('setLoading', false);
    //   },
    //   skip() {
    //     return !this.modelName
    //   }
    // }
  }

}
</script>
<style lang="scss">
.p-calendar .p-datepicker { padding: 0px !important; min-width: 100% !important;}
.p-calendar .p-datepicker td, .p-calendar .p-datepicker td a {padding: 0px !important;}
.p-calendar .p-datepicker td span {padding: 0px !important; width: 30px !important; height: 30px !important;}
.p-datepicker .p-datepicker-header{padding: 5px !important;}
.p-datepicker.p-datepicker-multiple-month .p-datepicker-group {
  border-right: 1px solid #d8dae2 !important;
  padding-left: 0.857rem !important;
  padding-right: 0.857rem !important;
  background: #fff !important;
}
.p-datepicker.p-datepicker-multiple-month .p-datepicker-group:last-child {
  border: 1px solid #c8c8c8 !important;
}
.doc-header {
  &.doc-title {
    color: #1D3118;
    text-transform: capitalize;
    font-size: 18px;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid #EEEEEE;
    .title-filter {
      margin-left: 24px;
    }
    .btn-enter-filter {
      background-color: #0A84FF !important;
      margin-left: 10px;
      padding: 6px 30px;
    }
  }
}
.box-selected-file {
  // padding: 10px; 
  position: relative; 
  width: fit-content;
  float: right;
  margin-top: 5px;
  margin-bottom: 5px;
  input.file {position: absolute; opacity: 0;cursor: pointer;}
}
.box-selected-file span {
  padding: 7px 15px; 
  background: #0A84FF 0% 0% no-repeat padding-box;
  border: 1px solid #0A84FF; 
  border-radius: 3px; 
  cursor: pointer;
  font-size: 0.875rem;
  color: #ffffff;
  .btn-span {
    background: #0A84FF 0% 0% no-repeat padding-box !important;
    border: 1px solid #0A84FF;
  }
}
.box-export-report {
  position: relative; 
  width: fit-content;
  float: right;
  margin-top: 5px;
  margin-bottom: 5px;
  margin-right: 10px;
  input.file {position: absolute; opacity: 0;cursor: pointer;}
  span {
    padding: 7px 15px; 
    background: #0A84FF 0% 0% no-repeat padding-box;
    border: 1px solid #0A84FF; 
    border-radius: 3px; 
    cursor: pointer;
    font-size: 0.875rem;
    color: #ffffff;
  }
}
</style>